import React, { forwardRef, useImperativeHandle } from 'react';

import { AnswerElement } from '@/components/Quiz/Answers/AnswerElement/AnswerElement';

type AnswersListProps = {
    className?: string;
    question: any;
    onDrop: (id?: string) => void;
    onDrag: () => void;
};

type OptionsRefsDict = {
    [key: string]: React.Ref<any> | null;
};

export const AnswersList = forwardRef(
    ({ className, question, onDrop, onDrag }: AnswersListProps, ref) => {
        const initOptionsRef = () => {
            const optionsArr = question.options;
            const result = {};
            optionsArr.forEach((record) => {
                result[record.id] = { ...React.createRef() };
            });
            return result;
        };

        const [optionsRefs, setOptionsRefs] = React.useState<OptionsRefsDict>(initOptionsRef());

        useImperativeHandle(ref, () => ({
            triggerError(id: string) {
                // @ts-ignore
                optionsRefs[id]?.current.triggerError();
            },
            triggerSuccess(id: string) {
                // @ts-ignore
                optionsRefs[id]?.current.triggerSuccess();
            },
        }));

        return (
            <ul className={className}>
                {question.options.map((option, index) => {
                    const { id } = option;
                    return (
                        <AnswerElement
                            key={id}
                            ref={optionsRefs[id]}
                            onDrop={onDrop}
                            id={id}
                            icon={option.svg}
                            text={option.text}
                            index={index}
                            unlock={() => {
                                // console.log(optionsRefs);
                                Object.keys(optionsRefs).forEach((refId) => {
                                    // @ts-ignore
                                    optionsRefs[refId]?.current.setLock(false);
                                });
                            }}
                            onDrag={() => {
                                onDrag();
                                // console.log(optionsRefs);
                                Object.keys(optionsRefs).forEach((refId) => {
                                    // @ts-ignore
                                    optionsRefs[refId]?.current.setLock(true);
                                });
                            }}
                        />
                    );
                })}
            </ul>
        );
    },
);

AnswersList.displayName = 'AnswersList';
